module.exports = __webpack_public_path__ + "static/media/Capacidades.316210d6.svg";